module.exports = __webpack_public_path__ + "static/media/productos_cacahuate_crudo.008897b5.png";